import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ConnectedFormSelect } from '../FormSelect/FormSelect.js';

const PrefixSelect = (props)=>{
    return /*#__PURE__*/ React.createElement(ConnectedFormSelect, swcHelpers.extends({
        id: "salutation",
        name: "salutation"
    }, props));
};

export { PrefixSelect };
//# sourceMappingURL=PrefixSelect.js.map
